import React from 'react';
import Icon, { IconProps } from './Icon';

const ShopAllIcon: React.FC<IconProps> = ({ size = 22, color = '#343B91', ...props }) => {
  return (
    <Icon size={size} color={color} viewBox="0 0 22 22" {...props}>
      <path
        d="M19.25 20.1674H10.0833M2.75 20.1674H6.41667"
        stroke={color}
        strokeWidth="1.375"
        strokeLinecap="round"
      />
      <path
        d="M17.417 20.1667V13.75"
        stroke={color}
        strokeWidth="1.375"
        strokeLinecap="round"
      />
      <path
        d="M4.58301 20.1667V13.75"
        stroke={color}
        strokeWidth="1.375"
        strokeLinecap="round"
      />
      <path
        d="M10.9991 1.83264H6.84861C5.74603 1.83264 5.19473 1.83264 4.75171 2.10645C4.30867 2.38026 4.06213 2.87334 3.56904 3.85952L2.28239 7.11199C1.98513 7.86344 1.72504 8.74912 2.22543 9.38368C2.56113 9.80938 3.0815 10.0826 3.66573 10.0826C4.67826 10.0826 5.49907 9.26186 5.49907 8.24931C5.49907 9.26186 6.31988 10.0826 7.3324 10.0826C8.34492 10.0826 9.16573 9.26186 9.16573 8.24931C9.16573 9.26186 9.98651 10.0826 10.9991 10.0826C12.0116 10.0826 12.8324 9.26186 12.8324 8.24931C12.8324 9.26186 13.6532 10.0826 14.6657 10.0826C15.6783 10.0826 16.4991 9.26186 16.4991 8.24931C16.4991 9.26186 17.3198 10.0826 18.3324 10.0826C18.9167 10.0826 19.4371 9.80938 19.7727 9.38368C20.2732 8.74912 20.0131 7.86344 19.7158 7.11199L18.4292 3.85952C17.9361 2.87334 17.6895 2.38026 17.2465 2.10645C16.8035 1.83264 16.2522 1.83264 15.1496 1.83264H14.6658"
        stroke={color}
        strokeWidth="1.375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export default ShopAllIcon;

